import Box from '@mui/material/Box';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import '@/Pages/Terms/TermsPage.sass';

type MarkdownContentProps = {
  content: string;
};

export function MarkdownContent({ content }: MarkdownContentProps): JSX.Element {
  return (
    <Box className="markdown-content" data-testid="markdown-content">
      <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{content}</ReactMarkdown>
    </Box>
  );
}
